import React, {FC} from "react";
import {PatternTypes, PatternTypesLabels} from "services/abuseWordsService";

export const AbusePatternTypeTag: FC<{ patternType: PatternTypes }> = ({patternType}) => {
    return (
        <span className={`badge bg-secondary mx-1`}>{PatternTypesLabels[patternType]}</span>
    );
}